import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { headerHeight } from '../../scripts/helpers';
import './editorial-banner.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initEditorialBanner = (context) => {
  const editorialBannerSection = context.closest('.shopify-section');
  if (!editorialBannerSection) return;
  gsap.registerPlugin(ScrollTrigger);
  const tl = gsap.timeline();
  const enterAnimation = [{ opacity: 0, y: 150 }, { opacity: 1, y: 0 }];
  const scrollTrigger = {
    ease: 'easing.Linear',
    trigger: editorialBannerSection,
    start: `-${headerHeight()}px top`,
    end: 'bottom',
    scrub: 1
  };

  const media = editorialBannerSection.querySelector('.editorial-banner__media-wrapper');
  tl.fromTo(media, enterAnimation[0], enterAnimation[1]);

  const title = editorialBannerSection.querySelector('.editorial-banner__title');
  title.querySelectorAll('[data-title-word]').forEach(word => {
    tl.fromTo(word, enterAnimation[0], enterAnimation[1]);
  });

  const description = editorialBannerSection.querySelector('.editorial-banner__description');
  if (description) {
    tl.fromTo(description, enterAnimation[0], enterAnimation[1]);
  }

  tl.to(media, { yPercent: -20, scrollTrigger: scrollTrigger });
  tl.to(title, { y: -300, scrollTrigger: scrollTrigger });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.editorial-banner__container'), (el) => {
    window.dAgency.initEditorialBanner(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.editorial-banner__container'), (el) => {
      window.dAgency.initEditorialBanner(el);
    });
  });
}
